import {IBienLaiThuCreateRequest} from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import {IMucThuTuyenSinhSelectRequest} from "../../../model/request/chung-tu-tuyen-sinh/IMucThuTuyenSinhSelectRequest";
import {IThuPhiTuyenSinhTab} from "../../../model/request/thu-phi-tuyen-sinh/IThuPhiTuyenSinhTab";
import {ITsHoSoThiSinh} from "../../../model/respone/category/ITsHoSoThiSinh";
import {IMucThuTuyenSinhViewModel} from "../../../model/respone/chung-tu-tuyen-sinh/IMucThuTuyenSinhViewModel";
import {IBienLaiThuHinhThucNopViewModel} from "../../../model/respone/chung-tu/IBienLaiThuHinhThucNopViewModel";
import {generateActionTypeIds} from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import {IQRCodeResponse} from "../../../model/respone/ngan-hang/IQRCodeResponse";
import {IBienLaiThuUpdateRequest} from "../../../model/request/bien-lai/IBienLaiThuUpdateRequest";
import {IBienLaiThuViewModel} from "../../../model/respone/bien-lai/IBienLaiThu";

export interface IThuPhiTuyenSinhTabActionTyes<T> {
    request: IMucThuTuyenSinhSelectRequest;
    data: T;
}

export interface IThuPhiTuyenSinhTabByIdActionTyes<T> {
    id: string;
    data: T;
}

export const eThuPhiTuyenSinhActionsObj = {
    ADD_NEW_TAB: {} as undefined | ITsHoSoThiSinh,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as IThuPhiTuyenSinhTab,
    CHANGEG_SELECTED_TAB: "",

    ADD_NEW_TAB_BY_ID: 0 as number,
    ADD_NEW_TAB_BY_ID_ERROR: "",

    LOAD_MUC_THU_START: {} as IMucThuTuyenSinhSelectRequest,
    LOAD_MUC_THU_SUCCESS: {} as IThuPhiTuyenSinhTabActionTyes<
        IMucThuTuyenSinhViewModel[]
    >,
    LOAD_MUC_THU_ERROR: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    CHANGE_MUC_THU_SELECTED_IDs: {} as IThuPhiTuyenSinhTabActionTyes<number[]>,
    CHANGE_STEP: {} as IThuPhiTuyenSinhTabActionTyes<number>,
    CHANGE_HINHTHUCNOP: {} as IThuPhiTuyenSinhTabActionTyes<
        IBienLaiThuHinhThucNopViewModel[]
    >,
    CHANGE_SO_TIEN_THUC_NOP: {} as IThuPhiTuyenSinhTabActionTyes<number>,
    CHANGE_GHI_CHU_KHOAN: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    CREATE_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
    CREATE_BIENLAITHU_SUCCESS: {} as IThuPhiTuyenSinhTabActionTyes<number>,
    CREATE_BIENLAITHU_ERROR: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    CHANGE_THONGTINBIENLAI: {} as IThuPhiTuyenSinhTabActionTyes<any>,

    // Sửa biên lai tại chỗ
    LOAD_EDIT_BIENLAI_START: {} as {
        id_bien_lai: number;
        request: IMucThuTuyenSinhSelectRequest;
    },
    LOAD_EDIT_BIENLAI_SUCCESS: {} as IThuPhiTuyenSinhTabActionTyes<IBienLaiThuViewModel>,
    LOAD_EDIT_BIENLAI_ERROR: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    CANCEL_EDIT_BIENLAI: {} as IMucThuTuyenSinhSelectRequest,
    UPDATE_BIENLAITHU_START: {} as IBienLaiThuUpdateRequest,
    UPDATE_BIENLAITHU_SUCCESS: {} as IThuPhiTuyenSinhTabActionTyes<number>,
    UPDATE_BIENLAITHU_ERROR: {} as IThuPhiTuyenSinhTabActionTyes<string>,

    PREVIEW_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
    PREVIEW_BIENLAITHU_SUCCESS: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    PREVIEW_BIENLAITHU_ERROR: {} as IThuPhiTuyenSinhTabActionTyes<string>,
    PREVIEW_BIENLAITHU_CLOSE: {} as IThuPhiTuyenSinhTabActionTyes<string>,

    UPDATE_QRCODE: {} as IThuPhiTuyenSinhTabByIdActionTyes<
        IQRCodeResponse | undefined
    >,
};
export const eThuPhiTuyenSinhActionIds = generateActionTypeIds(
    eThuPhiTuyenSinhActionsObj,
    "THU_PHI_TUYEN_SINH"
);
export type IThuPhiTuyenSinhActionTypes = IGenericActionType<
    typeof eThuPhiTuyenSinhActionsObj,
    "THU_PHI_TUYEN_SINH"
>;
